import { AxiosResponse } from "axios";
import { KeyValue, KeyValueDefault } from "@/main/models/common";
import { InsurerFilterRequest, InsurerSaveRequest } from "@/main/models/request/";
import {
	InsurerAgreementsResponse,
	InsurerRegistrationDataResponse,
	InsurerResponse,
	InsurerSaveRespose,
} from "@/main/models/response";
import { Result } from "@/main/models/common/resultResponse";

export abstract class IInsurerApi {
	abstract getInsurersOrInsurerBranchesDomain(
		request: InsurerFilterRequest,
	): Promise<AxiosResponse<Result<KeyValue[]>>>;

	abstract getInsurers(request: InsurerFilterRequest): Promise<AxiosResponse<InsurerResponse>>;

	abstract getInsurersFullDomain(request: InsurerFilterRequest): Promise<AxiosResponse<InsurerResponse>>;

	abstract getInsurersBodyshopAgreements(
		request: InsurerFilterRequest,
	): Promise<AxiosResponse<Result<InsurerAgreementsResponse[]>>>;

	abstract getRegistrationDataInsurer(
		request: InsurerFilterRequest,
	): Promise<AxiosResponse<Result<InsurerRegistrationDataResponse>>>;

	abstract saveInsurer(request: InsurerSaveRequest): Promise<AxiosResponse<Result<InsurerSaveRespose>>>;

	abstract getInsurersPublic(guidCountry: string): Promise<AxiosResponse<KeyValueDefault[]>>;
}
